module.exports = __webpack_public_path__ + "img/fundo-desconto-bolsas.3f7f4356.png";